import { Vec2 } from '../math/Vec2';
import { Ball } from './Ball';
import { BLACK_HOLE } from '../config/constants';

export class BlackHole {
  active: boolean = false;
  pos: Vec2 = Vec2.zero();
  timer: number = 0;
  radius: number = BLACK_HOLE.RADIUS;

  spawn(pos: Vec2, duration: number = BLACK_HOLE.DURATION_TICKS): void {
    this.pos = pos.clone();
    this.timer = duration;
    this.active = true;
  }

  update(balls: Ball[], arenaRadius: number): void {
    if (!this.active) return;

    this.timer--;
    if (this.timer <= 0) {
      this.active = false;
      return;
    }

    // Apply gravitational pull to all active balls
    for (const ball of balls) {
      if (ball.isDead) continue;

      const toHole = this.pos.sub(ball.pos);
      const dist = toHole.length();

      if (dist > 10 && dist < arenaRadius * 1.5) {
        const force = Math.min(BLACK_HOLE.MAX_FORCE, 10 / dist);
        const currentSpeed = ball.speed;

        const pullDir = toHole.scale(1 / dist);
        ball.vel = ball.vel.add(pullDir.scale(force));

        const newSpeed = ball.speed;
        if (newSpeed > 0 && currentSpeed > 0) {
          ball.vel = ball.vel.scale(currentSpeed / newSpeed);
        }
      }
    }
  }
}
